// PatientPicker — Patientensuche mit Vorschlagsliste.
//
// Tippen statt scrollen: findet Patienten über Namen ("Nachname, Vorname"
// oder "Vorname Nachname") ODER Geburtsdatum. Freitext bleibt erlaubt —
// wer nicht im Stamm ist, kann trotzdem eingetragen werden.
// onPick(patient) liefert den gewählten Datensatz für Auto-Ausfüllen.
import { useState, useMemo } from "react";
import { Input } from "./ui";
import { loadPatientsCache } from "./lib/patientStore";

export default function PatientPicker({ label = "Patient", value, onChange, onPick, placeholder = "Name oder Geburtsdatum tippen…", style = {} }) {
  const [open, setOpen] = useState(false);
  const pats = useMemo(loadPatientsCache, []);
  const q = (value || "").toLowerCase().trim();
  const sugg = useMemo(() => {
    if (q.length < 1) return [];
    return pats.filter(p => {
      const a = `${p.nachname}, ${p.vorname}`.toLowerCase();
      const b = `${p.vorname} ${p.nachname}`.toLowerCase();
      return a.includes(q) || b.includes(q) || (p.dob || "").includes(q);
    }).slice(0, 8);
  }, [q, pats]);
  const exact = pats.some(p => `${p.nachname}, ${p.vorname}`.toLowerCase() === q);

  return (
    <div style={{ position: "relative", ...style }}>
      <div onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}>
        <Input label={label} value={value} onChange={v => { onChange(v); setOpen(true); }} placeholder={placeholder} style={{ marginBottom: 10 }}/>
      </div>
      {open && sugg.length > 0 && !exact && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, marginTop: -6, background: "var(--mf-bg)", border: "0.5px solid var(--mf-border2)", borderRadius: 12, boxShadow: "0 8px 24px rgba(0,0,0,.14)", zIndex: 40, maxHeight: 220, overflowY: "auto" }}>
          {sugg.map((p, i) => (
            <div key={p.id ?? i}
              onMouseDown={() => { onChange(`${p.nachname}, ${p.vorname}`); if (onPick) onPick(p); setOpen(false); }}
              style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "0.5px solid var(--mf-border)", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}
              onMouseEnter={e => e.currentTarget.style.background = "var(--mf-bg-alt)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: "var(--mf-text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.nachname}, {p.vorname}</div>
                <div style={{ fontSize: 10, color: "var(--mf-muted)" }}>Geb. {p.dob || "—"}{p.email ? " · ✉" : ""}</div>
              </div>
              <span style={{ fontSize: 10, padding: "2px 7px", borderRadius: 20, background: "var(--mf-bg-alt)", color: "var(--mf-muted)", flexShrink: 0 }}>{p.kv || "—"}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
